export { default } from "./rotatedArrow";
